export default __webpack_public_path__ + "static/media/reddit.6749cd4c.svg";